import { Document, Paragraph, TextRun, HeadingLevel, AlignmentType, Table, TableRow, TableCell, UnderlineType} from "docx";
import { IScheduleA } from "./ScheduleAHooks";

// Documents contain sections, you can have multiple sections per document, go here to learn more about sections
// This simple example will only contain one section

// Columns 5-8 (ownership/third party details) are left blank for the artist/manager to fill in
const TABLE_HEADERS = [
    "#",
    "Artist(s)",
    "Title",
    "ISRC",
    "Percentage Owned by Artist",
    "Third Party Co-Owners and Percentages",
    "Third Party Participant (Feature / Remixer / Producer, etc.) Name",
    `Third Party Participant's Share of Net Receipts, (% or "N/A")`
]

const generateScheduleA = (scheduleAInput: IScheduleA[]): Document =>{
    const children: (Table | Paragraph)[] = []
    for (const album of scheduleAInput){
        const table = new Table({
            columnWidths: [400, 1150, 1900, 1250, 900, 950, 1500, 1300],
            rows: [
                new TableRow({
                    children: TABLE_HEADERS.map((header) =>
                        new TableCell({
                            children: [new Paragraph({children:[ new TextRun({text: header, bold:true})],alignment: AlignmentType.CENTER})]
                        })
                    ),
                }),
                ...tracks(album)

            ],
        });
        children.push(new Paragraph({text:""}))
        children.push(new Paragraph({
            children:[new TextRun({text: albumHeading(album), color:"#000000", underline: {type: UnderlineType.SINGLE }})],
          alignment: AlignmentType.LEFT
        }))
        children.push(new Paragraph({text:""}))
        children.push(table)


    }

    const doc = new Document({
        sections:[
            {
            children: [

                createHeading('Schedule "A"', HeadingLevel.HEADING_2),
                createHeading("The Existing Sound Recordings", HeadingLevel.HEADING_1),
                ...children
            ]
            }
        ]
    })
    return doc

}

const albumHeading = (album: IScheduleA): string =>{
    const format = album.albumType === "single" ? "single/ep" : album.albumType
    return `${album.albumName} (${format}) – UPC: ${album.upc ?? ""}`
}

const tracks = (album:IScheduleA): TableRow[]=>{
    const arr: TableRow[] = [];
    album.albumTracks.map((track)=>{
        if(track.isChecked){
            arr.push(new TableRow({

                children: [
                    new TableCell({
                        children: [new Paragraph(`${track.trackNumber}`)],

                    }),
                    new TableCell({
                        children: [new Paragraph(`${track.artists ?? ""}`)]

                    }),
                    new TableCell({
                        children: [new Paragraph(`${track.name}`)]

                    }),
                    new TableCell({
                        children: [new Paragraph(`${track.isrc ?? ""}`)]

                    }),
                    new TableCell({
                        children: [new Paragraph("")],

                    }),
                    new TableCell({
                        children: [new Paragraph("")],

                    }),
                    new TableCell({
                        children: [new Paragraph("")],

                    }),
                    new TableCell({
                        children: [new Paragraph("")],

                    })
                ]

            }))
        }
    })

    return arr
}

const createHeading = (text: string, heading: HeadingLevel): Paragraph =>{
    return new Paragraph({
        children:[new TextRun({text: text, color:"#000000"})],
      alignment: AlignmentType.CENTER,
      heading: heading
    });
  }

export {generateScheduleA}
